import React, { Component } from "react";
import { Link } from "react-router-dom";

interface NotFoundProps {}

class NotFound extends Component<NotFoundProps> {
  render() {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <h1 className="text-6xl font-bold text-red-600">404</h1>
        <p className="text-xl text-gray-600 mt-4">Pagina non trovata</p>
        <Link to="/" className="mt-6 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-700">
          Torna alla Home
        </Link>
      </div>
    );
  }
}

export default NotFound;

